var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"zodiac-box"},[_c('div',{staticClass:"zodiac-item",class:[_vm.zodiacClass]})])}
var staticRenderFns = []

export { render, staticRenderFns }